import React, { useState } from 'react';
import { Modal, Typography, Icon, Alert } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { ModalSelectedCardContentHolder } from './Styles/ModalSelectedCardContentStyle';

const { Text, Title } = Typography;

const ModalChangeCreationTypeWarning = ({isOpen, handleOk, handleCancel, action}) => {
  const { t } = useTranslation();

  const actionText = action === "createCampaign" ? t("Create campaign step title").toLowerCase() : t("Make a proposal step title").toLowerCase()

  return (
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>{t('Atention!')}</span>
          </div>
        }
        visible={isOpen}
        onOk={() => handleOk(action)}
        onCancel={handleCancel}
        okText={t('Confirm')}
        cancelText={t('Cancel')}
        okButtonProps={{ danger: true }}
      >
        <ModalSelectedCardContentHolder>
          <Title level={4}>{t('Are you sure you want to actionText?').replace('actionText', actionText)}</Title>
          <Alert
            description={<Trans i18nKey="All current progress will be lost" components={{ strong: <strong /> }} />}
            type="warning"
            showIcon
          />
        </ModalSelectedCardContentHolder>
      </Modal>
  );
};

export default ModalChangeCreationTypeWarning;